<!-- Diálogos de creación/edición de producto/servicio -->
<p-dialog
    [header]="producto && producto.id ? 'Editar Producto/Servicio' : 'Nuevo Producto/Servicio'"
    [(visible)]="visible"
    modal="modal"
    showEffect="fade"
    [breakpoints]="{ '960px': '75vw', '640px': '100vw' }"
    [style]="{ width: '75vw' }"
    [draggable]="false" 
    [resizable]="false"
    (onHide)="cerrarPopup(false);">
    <form
        #servicioEditorForm="ngForm"
        (ngSubmit)="guardarServicio()"
        [ngClass]="{ disabledForm: false }">
        <p-messages [(value)]="msgs"></p-messages>
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field col-12">
                <h2 class="p-text-uppercase">{{producto.name}}</h2>
            </div>
            <div class="p-field col-12 p-md-6">
                <label for="nombre">Nombre Producto/Servicio</label>
                <span class="p-input-icon-left">
                    <i class="pi pi-bookmark"></i>
                    <input
                        #nombre ="ngModel"
                        id="nombre"
                        name="nombre"
                        type="text"
                        [(ngModel)]="producto.name"
                        [pattern]="appConfig['validationRegExp']['safeMultilineTextPattern']"
                        required
                        pInputText 
                        placeholder="Ingrese el nombre del producto o servicio para la Factura"
                        />
                </span>
                <p-message
                    severity="error"
                    [text]="appConfig['validationMsgs']['safeMultilineTextPattern']"
                    *ngIf="
                    servicioEditorForm.controls['nombre'] &&
                    !servicioEditorForm.controls['nombre'].valid &&
                    (servicioEditorForm.controls['nombre'].dirty || servicioEditorForm.controls['nombre'].touched)
                    ">
                </p-message>
            </div>
            <div class="p-field col-12 p-md-6">
                <label for="stacked">Precio</label>
                <p-inputNumber 
                    #precio ="ngModel"
                    id="precio"
                    name="precio"
                    [(ngModel)]="producto.price"
                    [showButtons]="true" 
                    inputId="stacked" 
                    mode="currency"
                    currency="USD"
                    [minFractionDigits]="3"
                    placeholder="Ingrese el valor unitario del producto o servicio a facturar">
                </p-inputNumber>
                <p-message
                    severity="error"
                    [text]="appConfig['validationMsgs']['safeMultilineTextPattern']"
                    *ngIf="
                    servicioEditorForm.controls['precio'] &&
                    !servicioEditorForm.controls['precio'].valid &&
                    (servicioEditorForm.controls['precio'].dirty || servicioEditorForm.controls['precio'].touched)
                    ">
                </p-message>
            </div>

            <div class="p-field col-12 p-md-6">  
                <label for="tiposervicio">¿Producto o servicio?</label>    
                <div *ngFor="let category of productTypes" class="field-checkbox">
                    <br>
                    <p-radioButton 
                        #tiposervicio ="ngModel"
                        id="tiposervicio"
                        name="tiposervicio"
                        [(ngModel)]="productType" 
                        [inputId]="category.value" 
                        name="category" 
                        [value]="category" 
                        [disabled]="category.value === 'R'"></p-radioButton>
                    <label [for]="category.value">  {{category.name}}</label>
                </div>
                <p-message
                    severity="error"
                    [text]="appConfig['validationMsgs']['safeTextPattern']"
                    *ngIf="
                    servicioEditorForm.controls['tiposervicio'] &&
                    !servicioEditorForm.controls['tiposervicio'].valid &&
                    (servicioEditorForm.controls['tiposervicio'].dirty || servicioEditorForm.controls['tiposervicio'].touched)
                    ">
                </p-message>
            </div>
            <!-- TODO implementar selección de IVA -->
            <div class="p-field col-12 p-md-6">                
                <label for="iva">IVA {{ appConfig.app.iva.etiqueta }}</label>
                <p-inputSwitch 
                    #iva ="ngModel"
                    id="iva"
                    name="iva"
                    [(ngModel)]="iva12"
                    inputId="stacked" 
                    mode="currency"
                    ></p-inputSwitch>
            </div>

            <div class="p-field col-12 p-md-6">
                <label for="codigoPrincipal">Código principal (para auditoria)</label>
                <span class="p-input-icon-left">
                    <i class="pi pi-key"></i>
                    <input
                        #codigoPrincipal="ngModel"
                        id="codigoPrincipal"
                        name="codigoPrincipal"
                        type="text"
                        [(ngModel)]="producto.codigoPrincipal"
                        [pattern]="appConfig['validationRegExp']['codigoPattern']"
                        pInputText 
                        placeholder="Ingrese el código principal para efectos de auditoria"
                        />
                </span>
                <p-message
                    severity="error"
                    [text]="appConfig['validationMsgs']['codigoPattern']"
                    *ngIf="
                    servicioEditorForm.controls['codigoPrincipal'] &&
                    !servicioEditorForm.controls['codigoPrincipal'].valid &&
                    (servicioEditorForm.controls['codigoPrincipal'].dirty || servicioEditorForm.controls['codigoPrincipal'].touched)
                    ">
                </p-message>
            </div>
            <div class="p-field col-12 p-md-6">
                <label for="codigoAuxiliar">Código auxiliar (para auditoria)</label>
                <span class="p-input-icon-left">
                    <i class="pi pi-key"></i>
                    <input
                        #codigoAuxiliar ="ngModel"
                        id="codigoAuxiliar"
                        name="codigoAuxiliar"
                        type="text"
                        [(ngModel)]="producto.codigoAuxiliar"
                        [pattern]="appConfig['validationRegExp']['codigoPattern']"
                        pInputText 
                        placeholder="Ingrese el código principal para efectos de auditoria"
                        />
                </span>
                <p-message
                    severity="error"
                    [text]="appConfig['validationMsgs']['codigoPattern']"
                    *ngIf="
                    servicioEditorForm.controls['codigoAuxiliar'] &&
                    !servicioEditorForm.controls['codigoAuxiliar'].valid &&
                    (servicioEditorForm.controls['codigoAuxiliar'].dirty || servicioEditorForm.controls['codigoAuxiliar'].touched)
                    ">
                </p-message>
            </div>
        </div>

        <p-footer>
            <div class="p-d-flex p-flex-lg-row p-flex-column p-jc-end">
                <button
                    pButton
                    type="button"
                    label="{{ appConfig.ux.actions.cancel }}"
                    icon="pi pi-times"
                    class="p-button-secondary"
                    (click)="cerrarPopup(false);"></button>
                <button
                    pButton
                    type="submit"
                    label="{{ appConfig.ux.actions.save }}"
                    icon="pi pi-check"
                    class="p-ml-lg-1"
                    [disabled]="(!servicioEditorForm.valid)"></button>
            </div>
        </p-footer>
    </form>
</p-dialog>
